export default __webpack_public_path__ + "static/media/0xa25610a77077390a75ad9072a084c5fbc7d43a0d.9290dbc8.webp";